import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router , RouterModule } from '@angular/router';
import { ChangeEmailService } from './../../../_services/profile-settings/change-email.service';
import { Component, OnInit } from '@angular/core';

import { ErrorRedirectionService } from '../../../_services/error-service/error-redirection.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule],
  selector: 'app-change-email',
  templateUrl: './change-email.component.html',
})
export class ChangeEmailComponent implements OnInit {
  private token: string;
  private oldEmail: string;
  private requestBody: any = {};

  constructor(
    private changeEmailService: ChangeEmailService,
    private activatedRoute: ActivatedRoute,
    public router: Router,
    private errorRedirectionService: ErrorRedirectionService
  ) {}

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((queryParam) => {
      this.oldEmail = queryParam.oldEmail;
      this.token = queryParam.token;
      this.requestBody = {
        email: queryParam.newEmail,
        password: '',
      };
      this.changeEmailService
        .updateAccountEmail(this.oldEmail, this.token, this.requestBody)
        .subscribe(
          () => {
            localStorage.setItem('currentUser.username', queryParam.newEmail);
            this.router.navigate(['/my-insurance']);
          },
          (error) => {
            if (error.status) {
              this.errorRedirectionService.redirect(error.status);
            }
          }
        );
    });
  }
}
